import * as React from "react";
const SvgPlaceholder = props => /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 20,
  height: 20,
  style: {
    fill: "DeepPink"
  }
});
export default SvgPlaceholder;